import { useQuery } from "@tanstack/react-query";
import { TaskListDwo } from "../types/dailyTaskDwo";
import { getDailyTaskListDwo } from "../api/tasks";

export const dwoTaskListKeys = {
  all: ["hr-daily-task-dwo-list"] as const,
  list: (filters: Filters) =>
    [...dwoTaskListKeys.all, "list", filters] as const,
};

export interface Filters {
  page: number;
  date?: string; // YYYY-MM-DD
  employee_id?: number;
}

export type ApiResponseDwo = {
  page: number;
  pagesize: number;
  dwo_daily_trackers: TaskListDwo[];
  total: number;
};

export const useDwoTaskList = (filters: Filters) => {
  return useQuery<ApiResponseDwo>({
    queryKey: dwoTaskListKeys.list(filters),
    queryFn: () => getDailyTaskListDwo(filters),
    staleTime: 1000 * 60 * 60 * 3,
    gcTime: 1000 * 60 * 60 * 3,
    refetchOnWindowFocus: true,
  });
};
